// extracted by mini-css-extract-plugin
export default {"moveActions":"DndActions_moveActions__xTRDz","moveActionsDropZone":"DndActions_moveActionsDropZone__m16n+","moveActionsIcon":"DndActions_moveActionsIcon__iXgkk"};